import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Sparkles, RotateCcw } from "lucide-react";
import { api } from "../lib/api";

const STAGES = ["Enhancing your images", "Screening for visible findings", "Preparing your report"];

export default function Processing() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sid = params.get("sid");
  const [stage, setStage] = useState(0);
  const [error, setError] = useState(false);
  const started = useRef(false);

  const run = async () => {
    setError(false);
    setStage(0);
    const timer = setInterval(() => setStage((s) => (s < STAGES.length - 1 ? s + 1 : s)), 3000);
    try {
      await api.post(`/screenings/${sid}/analyze`);
      clearInterval(timer);
      navigate(`/report?sid=${sid}`, { replace: true });
    } catch (e) {
      clearInterval(timer);
      setError(true);
    }
  };

  useEffect(() => {
    if (!sid) return navigate("/intake");
    if (started.current) return;
    started.current = true;
    run();
  }, [sid]);

  return (
    <div className="min-h-screen w-full flex justify-center">
      <div className="relative w-full max-w-md min-h-screen brand-gradient flex flex-col items-center justify-center px-8 text-center">
        <div className="relative mb-8">
          <div className="w-28 h-28 rounded-full bg-[#8FE3BE]/20 pulse-soft" />
          <div className="absolute inset-0 flex items-center justify-center"><Sparkles className="w-12 h-12 text-[#8FE3BE]" /></div>
        </div>
        {!error ? (
          <>
            <h1 className="font-head font-extrabold text-2xl tracking-tight text-white">{STAGES[stage]}…</h1>
            <p className="text-white/70 text-sm mt-2 max-w-xs">This usually takes under a minute. Please keep this screen open.</p>
            <div className="flex gap-2 mt-8">
              {STAGES.map((_, i) => (<span key={i} className={`w-2 h-2 rounded-full ${i <= stage ? "bg-[#8FE3BE]" : "bg-white/25"}`} />))}
            </div>
          </>
        ) : (
          <>
            <h1 className="font-head font-extrabold text-2xl tracking-tight text-white">Something went wrong</h1>
            <p className="text-white/70 text-sm mt-2 max-w-xs">We couldn't complete the screening. Please try again.</p>
            <button data-testid="processing-retry" onClick={run}
              className="tap mt-8 h-12 px-6 rounded-2xl bg-white text-primary font-semibold flex items-center gap-2">
              <RotateCcw className="w-4 h-4" /> Retry
            </button>
          </>
        )}
      </div>
    </div>
  );
}
